import { AppState } from "../../../redux-configuration/AppState";
import { EcommerceOrder } from "../../domain/entities/ecommerceOrder";

export const loadEcommerceOrdersLoadingSelector = (appState: AppState): boolean => appState.ecommerce.order.list.loading
export const loadEcommerceOrdersErrorSelector = (appState: AppState): string | undefined => appState.ecommerce.order.list.error
export const ecommerceOrdersSelector = (appState: AppState): EcommerceOrder[] | undefined => appState.ecommerce.order.list.data
